import { useTranslation } from 'react-i18next';
import { WHATSAPP_BASE } from '@/constants';

export default function WhatsAppButton() {
  const { t } = useTranslation();
  const message = encodeURIComponent(t('whatsapp.message'));
  const href = `${WHATSAPP_BASE}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="nofollow noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-24 md:bottom-8 end-5 md:end-8 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white transition-transform hover:scale-105"
    >
      <i className="ri-whatsapp-line text-3xl" aria-hidden="true"></i>
    </a>
  );
}